import React, { useEffect, useState } from "react";
import UserModal from "../../components/EmailModal/UserModal";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import Storage from "../../utils/storage";
import { ReactComponent as DangerSign } from "../../assets/images/danger.svg";
import ThreeDot from "react-loading-indicators/ThreeDot";

const Loading = () => (
	<ThreeDot variant="bob" color="#ccc" size="small" text="" textColor=""  />
);

export const RunTestModal = ({
  showTestModal,
  hideTestModal,
  tid,
  myFunction,
  index,
  testIndex,
  portNo,
  copied,
  disabled,
  runTest,
  appId,
  companyId,
  type,
  userType,
  applicationHashValue,
  isApplicationHashLoaded,
  merchantClass,
}) => {
  const key1 = process.env.REACT_APP_API_COMPONENT_KEY_ONE;
  const key2 = process.env.REACT_APP_API_COMPONENT_KEY_TWO;
  const posVasIp = process.env.REACT_APP_API_POS_VAS_IP;
  const posVasPort = process.env.REACT_APP_API_POS_VAS_PORT;
  const empsIp = process.env.REACT_APP_API_EPMS_IP;
  const empsPort = process.env.REACT_APP_API_EPMS_PORT;

  const appHashValue = applicationHashValue?.merchantAppOnlyHashValue;
  const centerLongitude = applicationHashValue?.centerLongitude;
  const centerLatitude = applicationHashValue?.centerLatitude;
  const checkHashViolated = applicationHashValue?.hashValueViolatedStatus;
  const checkGeolocationViolated = applicationHashValue?.geofencingViolatedStatus;
  const merchantRadius = applicationHashValue?.merchantRadius;
  const terminalId = applicationHashValue?.terminalId;

  const [hashViolated, setHashViolated] = useState(false);
  const [geolocationViolated, setGeolocationViolated] = useState(false);

  useEffect(() => {
    if (isApplicationHashLoaded) {
      setHashViolated(checkHashViolated === "Y");
      setGeolocationViolated(checkGeolocationViolated === "Y");
    }
  }, [isApplicationHashLoaded, checkHashViolated, checkGeolocationViolated]);

  // prefer merchantClass from props (redux), fallback to localStorage
  const merchantClassValue = merchantClass || Storage.get("merchant_class");

  return (
    <UserModal open={showTestModal} close={hideTestModal} height={"800"} width={"555"}>
      <div style={{ display: "grid", placeItems: "center", justifyContent: "center" }}>
        <div style={{ padding: "20px" }}>
          {!isApplicationHashLoaded ? (
            <div className="loader" style={{ textAlign: "center", marginTop: "4em" }}>
              <p style={{marginBottom: "1em"}}>Loading application data...</p>
              <div style={{ display: "grid", placeItems: "center"}}><Loading /></div>
            </div>
          ) : (
            <>
              <div className="modal-header3">
                <h1>APPLICATION DETAILS</h1>
              </div>

              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ marginRight: "1em" }}>
                  <span>Hash Value</span>
                  {hashViolated ? (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm6.2 15.787l-1.413 1.413L12 13.413l-4.787 4.787-1.413-1.413L10.587 12 5.8 7.213 7.213 5.8 12 10.587l4.787-4.787 1.413 1.413-4.787 4.787 4.787 4.787z"
                        fill="#F44336"
                      />
                    </svg>
                  ) : (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-1.762 18.45l-6.3-6.3 1.427-1.426 4.872 4.872 9.393-9.393 1.427 1.426-10.392 10.393z"
                        fill="#4CAF50"
                      />
                    </svg>
                  )}
                </div>
                <div>
                  <span> Geolocation</span>
                  {geolocationViolated ? (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm6.2 15.787l-1.413 1.413L12 13.413l-4.787 4.787-1.413-1.413L10.587 12 5.8 7.213 7.213 5.8 12 10.587l4.787-4.787 1.413 1.413-4.787 4.787 4.787 4.787z"
                        fill="#F44336"
                      />
                    </svg>
                  ) : (
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-1.762 18.45l-6.3-6.3 1.427-1.426 4.872 4.872 9.393-9.393 1.427 1.426-10.392 10.393z"
                        fill="#4CAF50"
                      />
                    </svg>
                  )}
                </div>
              </div>

              <div className="tid-boxes">
                {!appHashValue && (
                  <>
                    <div
                      className="modal-header3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "2m",
                      }}
                    >
                      <DangerSign />
                      <h1 style={{ textAlign: "center", paddingLeft: "1em" }}>SDK NOT INITIALIZED</h1>
                    </div>
                    <p style={{ textAlign: "center", marginTop: "2em", marginBottom: "2em" }}>
                      The SDK hasn't been initialized, or it was initialized outside the designated geofencing area. Please download and implement the SDK using your Terminal ID at the specified location
                    </p>
                  </>
                )}

                <div className="tid-box">
                  <p>TID</p>
                  <span id="myInput">{tid}</span>
                  <button onClick={() => myFunction(tid, testIndex)}>{copied && tid === index ? "Copied!" : "Copy"}</button>
                </div>
                <div className="tid-box">
                  <p>Port Number</p>
                  <span id="myInput">{portNo}</span>
                  <button onClick={() => myFunction(portNo, testIndex)}>{copied && portNo === index ? "Copied!" : "Copy"}</button>
                </div>

                <div className="tid-box">
                  <p>App Hash</p>
                  <span id="myInput" style={{ width: "300px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{appHashValue}</span>
                  <button onClick={() => myFunction(appHashValue, testIndex)}>{copied && tid === index ? "Copied!" : "Copy"}</button>
                </div>
                <div className="tid-box">
                  <p>Center Longitude</p>
                  <span id="myInput">{centerLongitude}</span>
                  <button onClick={() => myFunction(centerLongitude, testIndex)}>{copied && centerLongitude === index ? "Copied!" : "Copy"}</button>
                </div>
                <div className="tid-box">
                  <p>Center Latitude</p>
                  <span id="myInput">{centerLatitude}</span>
                  <button onClick={() => myFunction(centerLatitude, testIndex)}>{copied && centerLatitude === index ? "Copied!" : "Copy"}</button>
                </div>
                <div className="tid-box">
                  <p>GeoFencing Radius</p>
                  <span id="myInput">{merchantRadius}</span>
                  <button onClick={() => myFunction(merchantRadius, testIndex)}>{copied && merchantRadius === index ? "Copied!" : "Copy"}</button>
                </div>

                <div className="tid-box">
                  <p>Component Key 1</p>
                  <span id="myInput">{key1}</span>
                  <button onClick={() => myFunction(key1, testIndex)}>{copied && key1 === index ? "Copied!" : "Copy"}</button>
                </div>
                <div className="tid-box">
                  <p>Component Key 2</p>
                  <span id="myInput">{key2}</span>
                  <button onClick={() => myFunction(key2, testIndex)}>{copied && key2 === index ? "Copied!" : "Copy"}</button>
                </div>
                <div className="tid-box">
                  <p>IP</p>
                  <span id="myInput">{posVasIp}</span>
                  <button onClick={() => myFunction(posVasIp, testIndex)}>{copied && posVasIp === index ? "Copied!" : "Copy"}</button>
                </div>
                <div className="tid-box">
                  <p>PORT</p>
                  <span id="myInput">{posVasPort}</span>
                  <button onClick={() => myFunction(posVasPort, testIndex)}>{copied && posVasPort === index ? "Copied!" : "Copy"}</button>
                </div>
                {/* <div className="tid-box">
                  <p>EPMS IP</p>
                  <span id="myInput">{empsIp}</span>
                  <button onClick={() => myFunction(empsIp, testIndex)}>{copied && empsIp === index ? "Copied!" : "Copy"}</button>
                </div>
                <div className="tid-box">
                  <p>EPMS PORT</p>
                  <span id="myInput">{empsPort}</span>
                  <button onClick={() => myFunction(empsPort, testIndex)}>{copied && empsPort === index ? "Copied!" : "Copy"}</button>
                </div> */}
              </div>

              <div className="form-grid-4">
                <div className="modal-input-button">
                  <button className="modal-close-button" type="button" onClick={hideTestModal}>
                    CANCEL
                  </button>
                </div>
                <div className="modal-input-button">
                  <button
                    type="submit"
                    className="modal-action-button"
                    onClick={() => runTest(appId, companyId, tid, portNo, type, merchantClassValue)}
                    disabled={!appHashValue || disabled || userType === "staff" || !merchantClassValue || !isApplicationHashLoaded}
                  >
                    RUN TEST
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </UserModal>
  );
};

const mapStateToProps = (state) => ({
  applicationHashValue: state.pos.applicationHashDetails,
  isApplicationHashLoaded: state.pos.isApplicationHashLoaded,
  merchantClass: state.docs && state.docs.merchantClass,
});

RunTestModal.propTypes = {
  appId: PropTypes.any,
  companyId: PropTypes.any,
  copied: PropTypes.any,
  disabled: PropTypes.any,
  hideTestModal: PropTypes.any,
  index: PropTypes.any,
  myFunction: PropTypes.func,
  portNo: PropTypes.any,
  runTest: PropTypes.func,
  showTestModal: PropTypes.any,
  testIndex: PropTypes.any,
  tid: PropTypes.any,
  type: PropTypes.any,
  userType: PropTypes.string,
  appHashValue: PropTypes.string,
  centerLatitude: PropTypes.number,
  centerLongitude: PropTypes.number,
  hashViolated: PropTypes.bool,
  geolocationViolated: PropTypes.bool,
  merchantRadius: PropTypes.number,
  applicationHashValue: PropTypes.object,
  isApplicationHashLoaded: PropTypes.bool,
  merchantClass: PropTypes.string,
};

export default connect(mapStateToProps)(RunTestModal);
